// https://blog.openreplay.com/forever-functional-waiting-with-promises/

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const untilAsync = async (fn: any, time = 1000, wait = 10000) => {
  const startTime = new Date().getTime(); /* [1] */
  for (;;) {
    /* [2] */
    if (await fn()) {
      /* [3] */
      return true;
    }

    if (new Date().getTime() - startTime > wait) {
      throw new Error("Max wait reached"); /* [5] */
    } else {
      /* [6] */
      await new Promise((resolve) => setTimeout(resolve, time));
    }
  }
};
